import { useState } from 'react';
import { Popover } from '@mantine/core';
import { Input } from '@shared/ui';

interface ScheduleTimeInputProps {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  className?: string;
}

const pad = (value: number) => String(value).padStart(2, '0');
const HOURS = Array.from({ length: 24 }, (_, index) => pad(index));
const MINUTES = Array.from({ length: 60 }, (_, index) => pad(index));

const toHm = (value: string) => {
  const match = value.match(/^(\d{2}):(\d{2})/);
  return match ? `${match[1]}:${match[2]}` : '';
};

export default function ScheduleTimeInput({
  value,
  onChange,
  disabled,
  className = '',
}: ScheduleTimeInputProps) {
  const [opened, setOpened] = useState(false);
  const [hour = '', minute = ''] = toHm(value).split(':');

  const pick = (nextHour: string, nextMinute: string) => {
    onChange(`${nextHour || '00'}:${nextMinute || '00'}`);
  };

  return (
    <Popover
      opened={opened && !disabled}
      onChange={setOpened}
      position="bottom-start"
      withinPortal
      zIndex={1100}
      offset={4}
    >
      <Popover.Target>
        <div className={`schedule-time-input ${className}`.trim()}>
          <Input
            type="time"
            size="xs"
            value={toHm(value)}
            disabled={disabled}
            onChange={(event) => onChange(event.currentTarget.value)}
            onFocus={() => setOpened(true)}
          />
        </div>
      </Popover.Target>
      <Popover.Dropdown
        className="schedule-time-dropdown"
        onMouseDown={(event) => event.preventDefault()}
      >
        <div className="schedule-time-dropdown__col">
          {HOURS.map((item) => (
            <button
              key={item}
              type="button"
              className={`schedule-time-dropdown__option${item === hour ? ' schedule-time-dropdown__option--active' : ''}`}
              onClick={() => pick(item, minute || '00')}
            >
              {item}
            </button>
          ))}
        </div>
        <div className="schedule-time-dropdown__col">
          {MINUTES.map((item) => (
            <button
              key={item}
              type="button"
              className={`schedule-time-dropdown__option${item === minute ? ' schedule-time-dropdown__option--active' : ''}`}
              onClick={() => {
                pick(hour || '00', item);
                setOpened(false);
              }}
            >
              {item}
            </button>
          ))}
        </div>
      </Popover.Dropdown>
    </Popover>
  );
}
